export class RenderError {
  name = 'RenderError'

  message: any = ''

  stack = ''

  constructor(options: { message: any; error?: Error; name?: string }) {
    const { message, error, name } = options
    this.message = message
    this.stack = (error || new Error()).stack
    this.name = name || this.name
  }
}
